<template>
    <div>
      
    </div>
</template>
<script>
import cookie from "@utils/store/cookie";

export default {
  name: "Index",
  components: {
  },
  props: {},
  data: function() {
    return {
    };
  },
  computed: {
  },
  mounted: function() {
    this.getHome();
  },
  watch: {
  },
  methods: {
    getHome() {
      const product = cookie.get("productId");
      if(product){
          if(product>1&&product<6){
              //特殊处理
              this.$router.push({path: '/detail/1'});
          }else{
            this.$router.push({path: '/detail/'+product});
          }
      }else{
        //请求后台服务，拉取用户最后一次访问的地址

      }
      // let that = this;
      // getHomeData().then(res => {
      //   that.mapKey = res.data.mapKey;
      //   cookie.set(MAPKEY, that.mapKey);
      //   that.logoUrl = res.data.logoUrl;
      //   that.$set(that, "banner", res.data.banner);
      //   that.$set(that, "menus", res.data.menus);
      //   that.$set(that, "roll", res.data.roll);
      //   that.$set(that, "info", res.data.info);
      //   that.$set(that, "firstList", res.data.firstList);
      //   that.$set(that, "bastList", res.data.bastList);
      //   that.$set(that, "likeInfo", res.data.likeInfo);
      //   that.$set(that, "lovely", res.data.lovely);
      //   // alert(res.data.benefit.length)
      //   that.$set(that, "benefit", res.data.benefit);
        
      //   that.setOpenShare();
      //   if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE))
      //     this.getWXLocation();
      // });
    },

  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.text .new-name {
  text-align: center !important;
  vertical-align: top;
}
.text .name .icon-shoucang {
  color: #ea3526 !important;
  margin-right: 0.1rem;
}
.text .name .icon-xinpin {
  color: blue !important;
}
.text .name .icon-jingpintuijian {
  color: blue !important;
}
</style>



<style scoped lang="scss">
	    .searchBar {
	        width: 100%;
	        .isFixed {
	            position: fixed;
	            width: 100%;
	            top: 0;
	            left: 0;
	            z-index: 999;
	        }
	        ul {
	            height: 40px;
	            line-height: 40px;
	            display: flex;
	            margin:0;
	            padding: 0;
	
	            li {
	                font-size: 0.8rem;
	                flex: 1;
	                display: flex;
	                justify-items: center;
	                justify-content: center;
	                align-items: center;
	                align-content: center;
	                position: relative;
	                background-color: #fff;
	                &.active {
	                    color: #847ec3;
	                    background-color: #e2e2e2;
	                    &:after {
	                        content: " ";
	                        position: absolute;
	                        height: 1px;
	                        width: 30px;
	                        bottom: 6px;
	                        left:calc(50% - 15px);
	                        border-top: 2px #847ec3 solid;
	                    }
	                }
	            }
	        }
	    }
	
	</style>